import { render, staticRenderFns } from "./FlowluLogo.vue?vue&type=template&id=0b839c17"
import script from "./FlowluLogo.vue?vue&type=script&lang=js"
export * from "./FlowluLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports